import React, { ReactElement } from 'react'

type AppThemeContextType = {
   theme: any //TODO:update type here,
   colorScheme: 'light' | 'dark'
}

const AppThemeContext = React.createContext<AppThemeContextType>({
   theme: {},
   colorScheme: 'light'
})

export const useAppTheme = () => {
   const context = React.useContext(AppThemeContext)

   if (!context) {
      throw new Error('Expected to be wrapped in Theme Context Provider')
   }

   return context
}

export const AppThemeProvider = ({
   children,
   theme,
   colorScheme
}: {
   children: ReactElement
   theme: any
   colorScheme: 'light' | 'dark'
}) => (
   <AppThemeContext.Provider
      value={{
         theme: theme[colorScheme],
         colorScheme: colorScheme ? colorScheme : 'light'
      }}
   >
      {children}
   </AppThemeContext.Provider>
)
